import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { GIButton, Modal } from 'app-components';
import { ModalContextType } from '@contexts/modalContext';
import { configs } from '@constants/configs/configs';
import { StyledModalButtonFooter } from '../voterRegistration.styled';
import useVoterRegistration from '../useVoterRegistration';
import { ConditionalRendering } from '@components/common/conditional-rendering';

interface IModalProps extends ModalContextType {
    isRetryAllowed?: boolean;
}

const VoterRegistrationFailureModal = ({ closeAllModals, isRetryAllowed = false }: IModalProps) => {
    const { stateElectionOfficeLink } = useVoterRegistration();
    const navigate = useNavigate();

    const handleClose = () => {
        closeAllModals();
    };

    const handleBackToDashboard = () => {
        handleClose();
        navigate(configs.routes.INDPORTAL);
    };

    return (
        <Modal id="voter_registration_failure_modal">
            <Modal.Header
                id="modal_header"
                titleId={'voterRegistration.form.modal.failure.header'}
                onHide={isRetryAllowed ? handleClose : handleBackToDashboard}
            />
            <Modal.Body>
                <p>
                    <FormattedMessage
                        id={
                            isRetryAllowed
                                ? 'voterRegistration.form.modal.failure.retry.body'
                                : 'voterRegistration.form.modal.failure.body'
                        }
                        values={{
                            anchor: function makeAnchorTag(chunks: any) {
                                return (
                                    <strong>
                                        <a href={stateElectionOfficeLink} target="_blank" rel="noopener noreferrer">
                                            {chunks}
                                        </a>
                                    </strong>
                                );
                            },
                        }}
                    />
                </p>
            </Modal.Body>
            <Modal.Controls>
                <StyledModalButtonFooter>
                    <ConditionalRendering isTrue={isRetryAllowed}>
                        <GIButton
                            id="back_to_dashboard_btn"
                            variant="secondary"
                            labelId="dashboard.back.link"
                            onClickHandler={handleBackToDashboard}
                        />
                    </ConditionalRendering>
                    <GIButton
                        id={isRetryAllowed ? 'continue_btn' : 'back_to_dashboard_btn'}
                        variant="primary"
                        labelId={isRetryAllowed ? 'button.continue' : 'dashboard.back.link'}
                        onClickHandler={isRetryAllowed ? handleClose : handleBackToDashboard}
                    />
                </StyledModalButtonFooter>
            </Modal.Controls>
        </Modal>
    );
};

export default VoterRegistrationFailureModal;
